import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LegalPage from '@/components/legal/LegalPage';

const CONTACT_EMAIL = 'offertes@powersure-worldwide.com';

export default function ContactPage() {
  const { t } = useTranslation();

  return (
    <LegalPage titleKey="legal.contact.title" testIdSuffix="contact">
      <p>{t('legal.contact.intro')}</p>

      <div className="mt-6 p-5 border border-border rounded-md bg-muted/40">
        <div className="flex items-center gap-3">
          <Mail className="w-5 h-5 text-muted-foreground" />
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-base font-medium underline decoration-from-font hover:text-primary"
            data-testid="contact-mailto-link"
          >
            {CONTACT_EMAIL}
          </a>
        </div>
        <p className="mt-3 text-sm text-muted-foreground">{t('legal.contact.responseTime')}</p>
      </div>

      <h2 className="text-lg font-semibold mt-8 mb-2 text-foreground" style={{ fontFamily: 'Outfit' }}>
        {t('legal.contact.whatToInclude')}
      </h2>
      <ul className="list-disc pl-6 space-y-1">
        {(t('legal.contact.includeList', { returnObjects: true }) || []).map((it, i) => (
          <li key={i}>{it}</li>
        ))}
      </ul>

      <p className="mt-8 text-sm text-muted-foreground">{t('legal.contact.privacyNote')}</p>
    </LegalPage>
  );
}
